module.exports = __webpack_public_path__ + "static/media/plane-poster.fb403b1f.png";